
//define system wide storage.
type TimeoutID = any;
let started :{[key:string]:TimeoutID}= {};
let lastDrop :{[key:string]:number}= {};

(window as any).__DEBUG_runAsyncTask = false;
/** Run async(delayed) task and cancel previous task
 * @param taskKey  - task key for drop controlling.
 * @param run  - closure to run.
 * @param timeout - start deplay for task. (for waiting next tasks)
 * @param passDropTimeout   drop timeout, when task started before dtopTimeout then previous wil be canceled.
 */
export function runAsyncTask(taskKey:string, run:()=>void, timeout :number = 100, passDropTimeout:number=0 )
{
	if ( started[taskKey] ) {
		if ( (window as any).__DEBUG_runAsyncTask) {
			console.log("cancel task:" + taskKey);
		}
		const now = Date.now();
		if ( lastDrop[taskKey] !== undefined && passDropTimeout > 0 ) {
			if ((now - lastDrop[taskKey]) < passDropTimeout) {
				clearTimeout(started[taskKey]);
			}
			//skip drop
		}
		else {
			clearTimeout(started[taskKey]);
		}
		lastDrop[taskKey] = now;
	}
	started[taskKey] = setTimeout(()=>{
		run();
		delete started[taskKey];
	}, timeout);
}
